import { Pipe, PipeTransform } from '@angular/core';
import { RuleActionConfig } from '@app/modules/identification/models/Rules';

@Pipe({
  name: 'estimatedOppUsed',
  standalone: false,
})
export class EstimatedOppUsedPipe implements PipeTransform {
  transform(actionSetItems: RuleActionConfig[] | { [key: string]: any }[]): boolean {
    if (actionSetItems) {
      return actionSetItems.some((x) => x.codeType === 'oppEstimate');
    }
    return true;
  }
}
